import ResizableDrawer from "@components/ResizableDrawer/ResizableDrawer"
import { Grid, List, ListItemButton, ListItemText, Typography } from "@mui/material"
import { GraphNodeData } from "@store/services/converter/types"
import { getDirectNodesOfGroup, getNotGroupedNodes } from "@utils/graph"

type NodeCategoriesDrawerProps = {
  groupId?: string
  onNodeListItemClick: (node: GraphNodeData) => void
  fillAvailableSpace?: boolean
}

const NodeCategoriesDrawer = (props: NodeCategoriesDrawerProps) => {
  const directNodes = props.groupId ? getDirectNodesOfGroup(props.groupId) : getNotGroupedNodes()

  return (
    <ResizableDrawer
      variant="permanent"
      SlideProps={{ appear: false }}
      open
      hideBackdrop
      disableEnforceFocus
      anchor="right"
      localStoragePrefix="categories-view"
      sx={props.fillAvailableSpace ? { width: "100%" } : undefined}
      PaperProps={{
        sx: {
          position: "relative",
          mt: 0,
          ...(props.fillAvailableSpace && { width: "100%" }),
        },
      }}
      enableMaximising={false}
    >
      <Grid
        container
        direction="column"
        sx={{ height: "100%" }}
        data-testid="category-view-nodes-sidebar"
      >
        <Grid item>
          <Typography variant="h6">Select a node:</Typography>
        </Grid>
        {directNodes.length === 0 && (
          <Grid container xs item direction="column" alignContent="center" justifyContent="center">
            <Grid item>
              <Typography>There is no direct node in this group</Typography>
            </Grid>
          </Grid>
        )}

        {directNodes.length > 0 && (
          <Grid item xs sx={{ overflow: "scroll" }}>
            <List dense>
              {directNodes.map((node) => (
                <ListItemButton
                  key={node.node.name}
                  onClick={() => props.onNodeListItemClick(node)}
                  data-testid={`node-list-item_${node.node.name}`}
                >
                  <ListItemText primary={node.display.label} />
                </ListItemButton>
              ))}
            </List>
          </Grid>
        )}
      </Grid>
    </ResizableDrawer>
  )
}

export default NodeCategoriesDrawer
